import { render, staticRenderFns } from "./groups.vue?vue&type=template&id=e7050dc4&scoped=true"
import script from "./groups.vue?vue&type=script&lang=js"
export * from "./groups.vue?vue&type=script&lang=js"
import style0 from "./groups.vue?vue&type=style&index=0&id=e7050dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7050dc4",
  null
  
)

export default component.exports